export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/83e791c702f67cc0242109b04d241be7.svg";